export enum HierarchyType {
  HEADQUARTERS = 'Headquarters',
  BRANCH = 'Branch',
}
